module.exports = __webpack_public_path__ + "assets/images/alimentacao_saude2.2281ca72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alimentacao_saude2.jpg
// module id = 804
// module chunks = 1